export class ApplicationFee {
    constructor (
        public TotalApplicationFee: number = 0,
        public ApplicantFee: number = 0,
        public ApplicationFee: number = 0,
        public WaivingFee: boolean = false,
        public AmountWaived: number = 0,
        public DisplayMessage: string = '',
        public AllApplicantsFirstNames: {} = null,
        public ApplicantsNotCompleteFirstNames: {} = null,
        public AllApplicantsComplete: boolean = true

    ) { }
}
